"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerType = void 0;
var CustomerType;
(function (CustomerType) {
    CustomerType["Private"] = "private";
    CustomerType["Business"] = "business";
})(CustomerType = exports.CustomerType || (exports.CustomerType = {}));
//# sourceMappingURL=customer-type.js.map